import React from 'react';

export default class ToggleOption extends React.Component
{
  render()
  {

    return (

      <div>
        <span style={ { paddingRight: '10px' } }>{ this.props.title }</span>

        <button onClick={ () => { this.props.onTrueState(); } } style={ { backgroundColor: this.props.currentState ? "green" : "grey" } } >
          True
        </button>
        <button onClick={ () => { this.props.onFalseState(); } } style={ { backgroundColor: !this.props.currentState ? "green" : "grey" } }>
          False
        </button>

      </div>

    );
  }
}
